import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, Input, Output, EventEmitter } from '@angular/core';

// INTERFACES
import { trackById } from '../../../shared/util/track-by.util';
import { IRfqProductSubstitution } from '../../interfaces/rfq.interface';

@Component({
  selector: 'lum-rfq-product-substitution-table',
  templateUrl: './rfq-product-substitution-table.component.html',
  styleUrls: ['./rfq-product-substitution-table.component.scss'],
})
export class RfqProductSubstitutionTableComponent {
  @Input()
  productSubstitutions :IRfqProductSubstitution[] = [];

  @Output()
  detachEvent = new EventEmitter<number>();

  @Output()
  dropEvent = new EventEmitter<CdkDragDrop<any[]>>();

  trackById = trackById;

  constructor() {}
}
